export default __webpack_public_path__ + "static/media/add-spirit.93e42ef0.svg";